import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToggleLabels } from '@models';

@Component({
  selector: 'toggle',
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss'
})
export class ToggleComponent {
  @Input() labels!: ToggleLabels;
  @Input() checked!: boolean;
  @Output() toggleClick = new EventEmitter<void>();

  onToggleClick() {
    this.toggleClick.emit();
  }
}
